export const SET_IS_LOADING = 'SET_IS_LOADING' as const;
export const SET_GENERATED_SECTION = 'SET_GENERATED_SECTION' as const;

const setIsLoading = (isLoading: boolean) => ({
  type: SET_IS_LOADING,
  isLoading,
});

const setGeneratedSection = (generatedSection: string) => ({
  type: SET_GENERATED_SECTION,
  generatedSection,
});

export const aiHtmlSectionActions = {
  setIsLoading,
  setGeneratedSection,
};

export type AiHtmlSectionActions =
  | ReturnType<typeof setIsLoading>
  | ReturnType<typeof setGeneratedSection>;
